import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function WorkCard({ item, onOpen, index = 0 }) {
  const [spot, setSpot] = useState({ x: 50, y: 50 });

  return (
    <motion.article
      data-testid={`work-card-${item.id}`}
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
      className="group relative cursor-pointer"
      onClick={() => onOpen?.(item)}
      onMouseMove={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        setSpot({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
      }}
    >
      <div className="chamfer bg-gradient-to-br from-[#2A3045] via-[#1E2335] to-[#2A3045] p-px transition-shadow duration-500 group-hover:shadow-[0_0_60px_rgba(0,240,255,0.12)]">
        <div
          className="chamfer relative overflow-hidden bg-[#0D0E15]"
          style={{
            background: `radial-gradient(700px circle at ${spot.x}% ${spot.y}%, rgba(0,240,255,0.08), transparent 45%), #0D0E15`,
          }}
        >
          <div className="relative overflow-hidden">
            <img
              src={item.image}
              alt={`${item.title} website concept by Fredline Studios`}
              className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07080C] via-transparent to-transparent opacity-80" />
            <span className="mono-label absolute top-4 left-4 border border-[#1E2335] bg-[#07080C]/80 px-3 py-1.5 backdrop-blur">
              {item.year} — {item.category}
            </span>
          </div>
          <div className="flex items-end justify-between gap-4 p-6 sm:p-7">
            <div>
              <h3 className="font-display text-2xl font-extrabold tracking-tight text-slate-100 sm:text-3xl">
                {item.title}
              </h3>
              <p className="mt-1 font-mono text-[11px] tracking-[0.2em] text-cyan-400/90 uppercase">{item.metric}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {item.tags.map((t) => (
                  <span key={t} className="border border-[#1E2335] px-2.5 py-1 text-[11px] text-slate-400">
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-[#1E2335] text-slate-400 transition-all duration-300 group-hover:border-cyan-400/60 group-hover:text-cyan-300 group-hover:shadow-[0_0_20px_rgba(0,240,255,0.25)]">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </div>
        </div>
      </div>
    </motion.article>
  );
}
